import { Event } from '@/event-bus/event';

export class ClientFiltersAppliedEvent extends Event<void> {}
